<template>
    <div style="background-color: white;">
        <!-- {{ certificate_data }} -->
        <!-- <br> ---------------------------- -->
        <!-- {{ json_data }} -->
        <div class="cardbody" v-if="json_data">
            <center>
                <div class="col-3 pb-none mb-none">
                    <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                </div>
            </center>
            <center>
                <h4 class="trust-name">
                    {{org_basic_data.trust_name}}
                </h4>
            </center>
            <center>
                {{org_basic_data.address}}
            </center>
            <center>
                Tel.: {{org_basic_data.phone}}, Website: {{org_basic_data.website}}
            </center>
            <hr class="hr-tag" />
            <strong> <span style="margin-left: 70%;"> Date:{{ certificate_data.cert_date }} </span> <br /> </strong>
            <center>
                <strong><h3 style="text-decoration: underline;">Bonafied Certificate</h3></strong>
            </center>
            <br />
            <div style="line-height: 2;" class="ml-5">
                <!-- {{ json_data }} -->
                 This is to certify that <strong>Miss / Master {{json_data.name}}</strong> is student of <br />
                Class : <strong> '{{certificate_data.std}}'</strong> Section : <strong> '{{certificate_data.div}}'</strong> for the year {{ certificate_data.ay }}. <br />
                His / Her details as per our records as follow: <br />
                <span v-if="json_data.dob"> Date Of Birth : <strong>{{json_data.dob}}</strong> <br /></span>
                <span v-if="json_data.birth_place"> Place Of Birth : {{ json_data.birth_place }} <br /></span>
                <span v-if="json_data.laddress"> Address : {{ json_data.laddress }} <br /></span>
                <span v-if="json_data.caste"> Caste : {{ json_data.caste }} </span>
            </div>
            <div class="row" style="margin-top: 150px; margin-left: 20px;">
                <img src="https://wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/hadapsar-auth-sign.jpeg" height="10%" width="20%" class="signature" alt="logo" />
                <br />
            </div>
           <span v-html="certificate_data.bonafite_cert_data"></span> 
           <!-- {{ certificate_data.bonafite_cert_data }} -->
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                certificate_id: null,
                org_basic_data: [],
                json_data: null,
            };
        },
        watch: {
            certificate_id() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.certificate_id = JSON.parse(this.$session.get("certificate_id"));
        },
        mounted() {
            this.getData();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            getData() {
                this.overlay = true;
                this.certificate_data = null;
                const formData = {
                    certificate_id: this.certificate_id,
                };
                axios
                    .post("/Certificate/getCertificate", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.certificate_data = res.data.certificate_data;
                            this.json_data = JSON.parse(this.certificate_data.json_data);
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    .cardbody {
        width: 750px;
        display: inline-block;
        background-color: white;
        height: 1100px;
        font-family: "Times New Roman", Times, serif;
        font-size: larger;
    }

    .schlImg {
        width: 84%;
        /* height: 60%; */
        margin-left: 10%;
    }
    .lcheading1 {
        /* margin-left: 16%; */
        width: 64%;
        border-radius: 17px;
        border: 1px solid black;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
        /* margin-left: -12px; */
        margin-bottom: 4px;
    }
    .lcheading2 {
        margin-left: 37%;
        width: 42%;
        border-radius: 6px;
        margin-top: 3px;
        border: 1px solid black;
        text-transform: uppercase;
    }
    .hr-tag2 {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 100%;
    }
    .dotted-underline {
        border-bottom: 1px dashed;
        /* line-height: 1.2rem; */
    }
    .school-info {
        line-height: 0.3rem;
    }
    .stud-info {
        line-height: 0.5rem;
    }

    @media print {
        .schlImg {
            width: 84%;
        }
        @page {
            size: A4;
            margin-top: 20px;
            padding-top: 10px;
            /* size: 11.5in 17.5in; */
            font-family: "Times New Roman", Times, serif;
            font-size: larger;
            size: 210mm 297mm;
            /* size: 10in 18in; */

            /* size: 10in 17in; */
        }
    }
    .stud_details2 {
        border-bottom: 1px solid black;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 98%;
        margin-left: 10px;
        margin-bottom: 4px;
    }
    div.row {
        margin-top: -10px;
    }
    .trust-name {
        /* margin-left: 22%; */
        text-transform: uppercase;
        font-size: x-large;
    }
</style>
